import React from 'react';

import { useMemoSelector } from 'hooks';
import promo from 'modules/promo';
import FeaturedTournamentsItem from './FeaturedTournamentsItem';

const {
    selectors: { selectFeaturedTournamentsList },
} = promo;

const FeaturedTournamentsList: React.FC = () => {
    const featuredConfigs = useMemoSelector(selectFeaturedTournamentsList);

    if (!featuredConfigs.size) return null;

    return (
        <React.Fragment>
            {featuredConfigs.map(config => (
                <FeaturedTournamentsItem key={config.slug} config={config} />
            ))}
        </React.Fragment>
    );
};

export default React.memo(FeaturedTournamentsList);
